import { queryBuilder } from '@lbs/swarm-client';

export const getBetSelectionListSwarmRequest = (eventIds, gameIds) => (
    queryBuilder()
        .useSource('betting')
        .selectSport(['id', 'alias'])
        .selectRegion(['id', 'alias'])
        .selectCompetition(['id'])
        // Used by ticket "copy to betslip" + cashier flows. Needs the
        // same shape the live game subscription returns so the copied
        // selections work end-to-end: navigation aliases (sport_alias /
        // region_alias), display data (team names, is_live), market
        // metadata (express_id / market_type for the express-id /
        // bet-builder rules), and the bet-builder odds fields
        // (type_id / type_1 / home_value / away_value) — without them
        // get_bet_builder_odds silently rejects every BB leg restored
        // from a ticket.
        .selectGame([
            'id',
            'team1_name',
            'team2_name',
            'is_blocked',
            'is_live',
            'sport_alias',
            'region_alias',
            'start_ts',
        ])
        .selectMarket(['id', 'name', 'display_key', 'express_id', 'market_type', 'type'])
        .selectEvent([
            'id',
            'order',
            'name',
            'price',
            'type',
            'type_id',
            'type_1',
            'base',
            'game_id',
            'home_value',
            'away_value',
        ])
        .whereGame('id').in(gameIds)
        .whereEvent('id').in(eventIds)
        .getParams()
);

export const getBookingSelectionListSwarmRequest = (eventIds, gameIds) => (
    queryBuilder()
        .useSource("betting")
        .selectSport(["id", "alias"])
        .selectRegion(["id", "alias"])
        .selectCompetition(["id"])
        // sport_alias / region_alias are the denormalised flat fields the
        // navigation helpers (goToGame, betBuilderGroup) read off the game
        // object. Without them in the projection, restored selections
        // produce URLs like `/betting/prematch/all//Europe/566/29706036`
        // (empty sport slot → 404) when the user clicks the BB card.
        // start_ts is added so the live/prematch decision uses the
        // canonical kickoff timestamp rather than `is_live` alone.
        .selectGame([
            "id",
            "team1_name",
            "team2_name",
            "is_blocked",
            "is_live",
            "sport_alias",
            "region_alias",
            "start_ts",
        ])
        .selectMarket(["id", "name", "display_key", 'express_id', 'market_type', 'type'])
        // type_id / type_1 / home_value / away_value are required by
        // `get_bet_builder_odds`. Without them, restored bet builder legs
        // come through with home_value=0/type_id=undefined and the BB API
        // rejects every selection. The standard game-view swarm
        // subscription includes these implicitly; the booking-restore
        // tree must request them explicitly.
        .selectEvent([
            "id",
            "price",
            "name",
            "base",
            "type",
            "type_id",
            "type_1",
            "home_value",
            "away_value",
        ])
        .whereGame("id")
        .in(gameIds)
        .whereEvent("id")
        .in(eventIds)
        .getParams()
);